(() => {
  const key = Symbol.for("speclang.dailyExpiry");
  if (window[key]) { window[key].mount(document); return; }
  const records = new Map();
  let timer = null, observer = null, suspended = false;
  const selector = "[data-speclang-daily]";
  const revoke = el => {
    el.querySelectorAll("[data-deal-active]").forEach(n => { n.hidden = true; });
    el.querySelectorAll("[data-deal-fallback]").forEach(n => { n.hidden = false; });
  };
  const stopTimer = () => {
    if (timer !== null) { clearInterval(timer); timer = null; }
  };
  const tick = () => {
    const now = Date.now();
    for (const [el, record] of records) {
      if (!el.isConnected) { records.delete(el); continue; }
      if (record.revoked || !Number.isFinite(record.start) ||
          !Number.isFinite(record.end) || record.end - record.start !== 86400000 ||
          now < record.start || now >= record.end) {
        record.revoked = true;
        el.dataset.dailyRevoked = "1";
        revoke(el);
        records.delete(el);
      }
    }
    if (!records.size) stopTimer();
  };
  const mount = root => {
    if (suspended) return;
    const elements = Array.from(root.querySelectorAll(selector));
    if (root.matches && root.matches(selector)) elements.unshift(root);
    const ancestor = root.closest && root.closest(selector);
    if (ancestor && !elements.includes(ancestor)) elements.unshift(ancestor);
    for (const el of elements) {
      if (el.dataset.dailyRevoked === "1") { revoke(el); continue; }
      if (records.has(el)) continue;
      records.set(el, {
        start: Date.parse(el.dataset.startsAt), end: Date.parse(el.dataset.endsAt),
        revoked: false
      });
    }
    tick();
    if (records.size && timer === null) timer = setInterval(tick, 1000);
  };
  const refresh = () => { mount(document); tick(); };
  const onSectionLoad = event => mount(event.target);
  const onSectionUnload = event => {
    for (const el of records.keys()) {
      if (el === event.target || event.target.contains(el)) records.delete(el);
    }
    if (!records.size) stopTimer();
  };
  const observe = () => {
    if (observer) observer.disconnect();
    observer = new MutationObserver(changes => {
      for (const change of changes) for (const node of change.addedNodes) {
        if (node.nodeType === 1) mount(node);
      }
      tick();
    });
    observer.observe(document.documentElement, {childList: true, subtree: true});
  };
  const onPageShow = () => { suspended = false; observe(); refresh(); };
  const onPageHide = event => {
    suspended = true; stopTimer();
    if (observer) observer.disconnect();
    if (!event.persisted) destroy();
  };
  const destroy = () => {
    suspended = true; stopTimer(); records.clear();
    if (observer) observer.disconnect();
    document.removeEventListener("visibilitychange", refresh);
    document.removeEventListener("shopify:section:load", onSectionLoad);
    document.removeEventListener("shopify:section:unload", onSectionUnload);
    document.removeEventListener("DOMContentLoaded", start);
    window.removeEventListener("pageshow", onPageShow);
    window.removeEventListener("pagehide", onPageHide);
    delete window[key];
  };
  const start = () => { observe(); refresh(); };
  window[key] = {mount, destroy};
  document.addEventListener("visibilitychange", refresh);
  document.addEventListener("shopify:section:load", onSectionLoad);
  document.addEventListener("shopify:section:unload", onSectionUnload);
  window.addEventListener("pageshow", onPageShow);
  window.addEventListener("pagehide", onPageHide);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start, {once: true});
  else start();
})();
